module.exports = __webpack_public_path__ + "static/media/c9bannerModul4_small.488d7346.jpg";